import { Component, input } from '@angular/core';
import { Box1Component } from "src/app/fitur-26/layout/boxes";
import { NewChatBotComponent } from 'src/chatbot/chatbot.component';
import { InfoRouteComponent } from './components/info-route/info-route.component';

@Component({
  selector: 'app-info-and-chat',
  standalone: true,
  imports: [
    Box1Component,
    NewChatBotComponent,
    InfoRouteComponent
],
  templateUrl: './info-and-chat.component.html',
  styleUrls: ['./info-and-chat.component.scss'],
  host: {
    style: `display: flex; 
            justify-content: center; 
            align-items: center; 
            width: 1100px; 
            height: 100%;
            margin: 0 auto;
          `
  }
})
export class InfoAndChatComponent {
  public chatId = input.required<string>();
}
